import { useTranslation } from 'react-i18next'


import { CustomerMessage, ProfileCustomerInfo } from '@entities/User'
import stylesMessage from '@entities/User/ui/profile/styles.module.scss'

import styles from '@features/auth/ui/styles.module.scss'
import { useModalStore } from '@features/modal'


export default function useProfileCustomerModal () {
  const { openModal, closeModal } = useModalStore()
  const { t: tu } = useTranslation('user')

  const openProfileCustomerModal = (onCloseCallback?: () => void) => {
    openModal('profileCustomerInfo', <ProfileCustomerInfo />, {
      title: tu('profileInfo.title'),
      description: tu('profileInfo.description'),
      classes: {
        content: styles.content,
      },

      onClose: () => {
        openModal(
          'customerMessage',
          <CustomerMessage onCloseCallback={onCloseCallback} />,
          {
            title: tu('customerRegister.title'),
            description: tu('customerRegister.description'),
            classes: {
              content: stylesMessage['modal-content'],
            },
            onClose: () => {
              if (onCloseCallback) {
                onCloseCallback()
              }
            },
          },
        )
      },
    })
  }
  const closeProfileCustomerModal = () => closeModal('profileCustomerInfo')

  return {
    openProfileCustomerModal,
    closeProfileCustomerModal,
  }
}
